<template>
  <nav
    v-if="breadcrumbList.length || historyLength"
    class="breadcrumbs"
    :aria-label="$string('general.breadcrumbs.accessibility.aria_label')"
  >
    <ol
      class="breadcrumbs__list"
      :class="page"
    >
      <li
        v-if="page === 'product' && historyLength"
        class="breadcrumbs__list-item"
      >
        <button
          class="breadcrumbs__single-breadcrumb back-button"
          type="button"
          @click.prevent="goToPrevPage"
        >
          <span
            class="text-body-2xs-regular"
            v-text="'<'"
          />

          <span
            class="text-body-2xs-regular"
            v-text="$string('general.breadcrumbs.back')"
          />
        </button>

        <span
          v-if="breadcrumbList.length"
          class="breadcrumbs__divider"
          v-text="`|`"
        />
      </li>

      <li
        v-for="(breadcrumb, index) of breadcrumbList"
        :key="index"
        class="breadcrumbs__list-item"
      >
        <btn
          class="breadcrumbs__single-breadcrumb"
          :label="breadcrumb.title"
          modifiers="text"
          type="button"
          :url="breadcrumb.url"
        />

        <span
          v-if="index < breadcrumbList.length - 1"
          class="breadcrumbs__divider"
          v-text="`/`"
        />
      </li>
    </ol>
  </nav>
</template>

<script>

/**
 * Vue: Breadcrumbs (breadcrumbs)
 * -----------------------------------------------------------------------------
 * Site breadcrumb navigation links.
 *
 * @param {Object} links - Tier 2 and 3 breadcrumb links.
 * @param {Boolean} showHomeLink - Display home link in breadcrumbs.
 */
import Btn from '~global/btn/btn'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Breadcrumbs',

  components: {
    Btn,
  },

  props: {
    breadcrumbList: {
      type: [Boolean, Array],
      default: () => [],
    },
    page: {
      type: String,
      default: 'collection',
    },
  },

  computed: {

    /**
     * Check if previous page exists
     */
    historyLength() {
      return window.history?.length > 2
    },
  },

  methods: {

    /**
     * Go to previous page
     */
    goToPrevPage() {
      history.back()
    },
  },
}
</script>

<style lang="scss">
@import './breadcrumbs';
</style>
